import { ShippedHazardousGoods, TruckType, TunnelCategory } from './TruckOptions';

export type TransportModes = `car` | `truck` | `bicycle` | `pedestrian` | `scooter`;

export const TRANSPORT_MODES = [`car`, `truck`, `bicycle`, `pedestrian`, `scooter`] as TransportModes[];

export const AVOID_FEATURES = [
  `tollRoad`,
  `controlledAccessHighway`,
  `ferry`,
  `carShuttleTrain`,
  `tunnel`,
  `dirtRoad`,
  `difficultTurns`,
  `uTurns`,
] as const;

export type AvoidFeature = (typeof AVOID_FEATURES)[number];

export interface TrafficOptionsDTO {
  multiplier?: number;
  mode?: TransportModes;
  departure_at?: Date | 'now';
  truck?: TruckOptionsDTO;
  avoid?: {
    features: Array<AvoidFeature>;
  };
}

export interface TruckOptionsDTO {
  shipped_hazardous_goods?: ShippedHazardousGoods[];
  gross_weight?: number;
  height?: number;
  width?: number;
  length?: number;
  tunnel_category?: TunnelCategory;
  axle_count?: number;
  type?: TruckType;
  trailer_count?: number;
}
